import { render } from "./BaseIconFitWidth.vue?vue&type=template&id=69d39fac"
const script = {}

import exportComponent from "/home/projects/cc-gastro/htdocs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/BaseIconFitWidth.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "69d39fac"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('69d39fac', __exports__)) {
    console.log('reload')
    api.reload('69d39fac', __exports__)
  }
  
  module.hot.accept("./BaseIconFitWidth.vue?vue&type=template&id=69d39fac", () => {
    console.log('re-render')
    api.rerender('69d39fac', render)
  })

}


export default __exports__